export const css = {
    root: '_1lx9YqP3',
    ' _key': 'apic-theme/apic/lcc-app/content'
};
export default css;
